// import Alert from './alert';

(function ($) {
    const conditionalFields = $('[data-conditional-field]');
    conditionalFields.each(function () {
        const condField = $(this);
        const settings = JSON.parse(condField.attr('data-conditional-field'));

        const {
            is_toggleable,
            conditional_field_name,
            conditional_field_value,
            conditional_field_condition,
        } = settings;

        if (is_toggleable) {
            const condSelectEl = $(`select[name="${conditional_field_name}"]`);
            const condSelectElValue = condSelectEl.val();

            condSelectEl.on('select2:select', function (e) {
                const selVal = $(this).val();
                checkConditionalSelect(
                    condField,
                    conditional_field_value,
                    conditional_field_condition,
                    selVal
                );
            });

            checkConditionalSelect(
                condField,
                conditional_field_value,
                conditional_field_condition,
                condSelectElValue
            );
        }
    });

    function modifyFormDataConditionals(formData) {
        conditionalFields.each(function () {
            const condField = $(this);
            const settings = JSON.parse(
                condField.attr('data-conditional-field')
            );

            const {
                is_toggleable,
                conditional_field_name,
                conditional_field_value,
                conditional_field_condition,
            } = settings;

            if (is_toggleable) {
                const condSelectEl = $(
                    `select[name="${conditional_field_name}"]`
                );
                const condSelectElValue = condSelectEl.val();

                checkFormDataConditionals(
                    formData,
                    condField,
                    conditional_field_value,
                    conditional_field_condition,
                    condSelectElValue
                );
            }
        });
    }

    function checkFormDataConditionals(
        formData,
        field,
        fieldValue,
        condition,
        selectValue
    ) {
        const fieldName = field.attr('name');

        if (condition === 'equal' && selectValue !== fieldValue)
            formData.delete(fieldName);

        if (condition === 'not_equal' && selectValue === fieldValue)
            formData.delete(fieldName);
    }

    function checkConditionalSelect(field, fieldValue, condition, selectValue) {
        if (condition === 'equal') {
            if (selectValue === fieldValue) {
                field.closest('.form__field').removeClass('hidden');
            } else {
                field.closest('.form__field').addClass('hidden');
            }
        }

        if (condition === 'not_equal') {
            if (selectValue !== fieldValue) {
                field.closest('.form__field').removeClass('hidden');
            } else {
                field.closest('.form__field').addClass('hidden');
            }
        }
    }

    $('.js-cf-form').on('submit', function (e) {
        e.preventDefault();

        const $form = $(this);
        let data = $form.serialize();
        // const alertWrapper = $form[0].querySelector('.form-alert');

        $form.addClass('is-loading');

        const recaptchaKey = $form.find('#g-recaptcha').val();
        const formId = $form.attr('id');
        let formObject = document.getElementById(formId);
        const formData = new FormData(formObject);
        modifyFormDataConditionals(formData);

        const filesToUpload = $form.find('[type="file"]');
        const $output = $form.find('.js-form-output');

        // grecaptcha.ready(function () {
        //     grecaptcha
        //         .execute(recaptchaKey, { action: 'submit' })
        //         .then(function (token) {
        //             formData.append('g_recaptcha_token', token);

                    $.ajax({
                        type: 'post',
                        url: ajax.url,
                        data: formData,
                        processData: false,
                        contentType: false,
                        beforeSend: function () {
                            $('.js-cf-error').remove();
                            $('.js-form-field').removeClass('error');
                            $form
                                .find('.js-form-output')
                                .removeClass(
                                    'has-errors is-warning is-success'
                                );

                            $('.js-cf-form__status').removeClass('success');
                            $('.js-cf-form__status').hide();
                            $('.js-cf-form__status span').html('');
                        },
                        success: function (response) {
                            response = $.parseJSON(response);

                            console.log(response);

                            if (response.status == 'ERROR') {
                                $.each(
                                    response.errors.fields,
                                    function (key, value) {
                                        const $parent = $form
                                            .find(`[name="${key}"]`)
                                            .parents('.js-form-field');
                                        $parent.addClass('error');
                                        $parent.append(
                                            `<div class='js-cf-error form__error'>${value}</div>`
                                        );

                                        const multipleParent = $form // check for inputs with multiple values (eg. files)
                                            .find(`[name="${key}[]"]`)
                                            .parents('.js-form-field');

                                        multipleParent.addClass('error');
                                        multipleParent.append(
                                            `<div class='js-cf-error form__error'>${value}</div>`
                                        );
                                    }
                                );
                                $output.addClass('has-errors');
                            } else if (response.status == 'WARNING') {
                                $form.find('input').val('');
                                $form.find('textarea').val('');
                                $form
                                    .find('input[type="checkbox"]')
                                    .prop('checked', false);
                                $output.addClass('is-warning');
                            } else {
                                $form.find('input').val('');
                                $form.find('textarea').val('');
                                $form
                                    .find('input[type="checkbox"]')
                                    .prop('checked', false);
                                $output.addClass('is-success');
                            }
                            $output.text(response.status_msg);
                            $form.removeClass('is-loading');
                        },
                    });
        //         });
        // });
    });
})(jQuery);
